import { render, staticRenderFns } from "./WebpayNotifications.vue?vue&type=template&id=6a50e952&"
import script from "./WebpayNotifications.vue?vue&type=script&lang=js&"
export * from "./WebpayNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports